var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal-target',{attrs:{"name":"yokyo-container"}}),_c('div',{staticClass:"mb__image-upload"},[_c('q-upload-single-image',{ref:"uploadSingleImage",attrs:{"options":{
        acceptedFiles: '.jpg, .jpeg, .png',
        maxFilesize: 5,
      },"showUploadImg":false},on:{"changed":function (files) {
          var _obj;

          _vm.uploadFile(files);
          _vm.errors = Object.assign({}, this$1.errors, ( _obj = {}, _obj['imageId'] = [], _obj ));
        },"showError":function () {
          this$1.errors = Object.assign({}, this$1.errors,
            {
              imageId: { 0: this$1.$t('common.message.errors.image') },
            });
        },"uploading":_vm.uploadStatus,"cancel":_vm.handleCancel},scopedSlots:_vm._u([{key:"add-image-btn",fn:function(action){return [_c('portal',{attrs:{"to":"yokyo-container"}},[_c('a',{staticClass:"mb__button mb__m-bottom-sm",style:({ pointerEvent: _vm.isLoading ? 'none' : 'auto' }),on:{"click":action.add}},[_vm._v("アップロード")])])]}}])})],1),_c('QErrors',{attrs:{"errors":_vm.errors,"name":'imageId'}}),_vm._t("showcase",null,{"deleteEventImage":_vm.deleteEventImage})],2)}
var staticRenderFns = []

export { render, staticRenderFns }